import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { ForgeBuilderContent } from "../forgeContent.js";

/**
 * The forge builder, showroom layout, after 13 · Exchange's pick and checkout steps: the details
 * and the item picker on the left, the pull rates and the summary beside them, held in view while
 * the picker scrolls. On phones it stacks in step order, and the summary's action bar floats at
 * the bottom. A notice, when there is one, takes the builder's place.
 */
export function ForgeBuilderShowroomLayout({ sections }: PageLayoutProps<ForgeBuilderContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-28 md:gap-8 md:pb-20">
      {sections.heading}
      {sections.notice}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,26rem)]">
        <div className="flex min-w-0 flex-col gap-5">
          {sections.details}
          {sections.picker}
        </div>
        <div className="flex min-w-0 flex-col gap-5 lg:sticky lg:top-28 lg:self-start">
          {sections.rates}
          {sections.summary}
        </div>
      </div>
    </Section>
  );
}
